import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@freelancer/location';
import { ModalRef } from '@freelancer/ui';
import { UserAgent } from '@freelancer/user-agent';
import { CookieService } from 'ngx-cookie';
import { LoginOrSignup } from './login-signup-modal.model';
@Component({
  selector: 'app-login-signup-modal',
  template: `
    <app-login
      *ngIf="form === LoginOrSignup.LOGIN"
      flTrackingSection="FreelancerLoginModal"
      [isModal]="true"
      (switchToSignup)="switchPage(LoginOrSignup.SIGNUP)"
      (success)="handleSuccess($event)"
    ></app-login>
    <app-signup
      *ngIf="form === LoginOrSignup.SIGNUP"
      flTrackingSection="FreelancerSignupModal"
      [isModal]="true"
      (switchToLogin)="switchPage(LoginOrSignup.LOGIN)"
      (success)="handleSuccess($event)"
    ></app-signup>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginSignupModalComponent {
  LoginOrSignup = LoginOrSignup;

  @Input() form: LoginOrSignup = LoginOrSignup.LOGIN;

  constructor(
    private activatedRoute: ActivatedRoute,
    private cookies: CookieService,
    private location: Location,
    private modalRef: ModalRef<LoginSignupModalComponent>,
    private userAgent: UserAgent,
  ) {}

  switchPage(form: LoginOrSignup) {
    this.form = form;
  }

  handleSuccess(user: number) {
    // FIXME: T143187 Do a hard reload if on Mobile until Mobile Web is removed.
    if (
      this.userAgent.isMobileDevice() &&
      this.cookies.get('mobile_optout') !== 'true' &&
      this.activatedRoute.snapshot.queryParamMap.get('mobile_optout') !== 'true'
    ) {
      this.location.redirect(this.location.href);
    } else {
      this.modalRef.close(user);
    }
  }
}
